import React, { useState } from 'react';
import { useNavigate, LinkProps } from 'react-router-dom';
import { Container, Button, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';
import pluralize from 'pluralize';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { ConfirmModal } from '@components/Base';
import { useQuoteOptionParams } from '@components/Feature/HealthQuote/hook';

import { useInsurancePage } from '../hook';

type Props = {
  formLinkTo: LinkProps['to'];
};

const SubHeader = ({ formLinkTo }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { spouse, sons, daughters } = useQuoteOptionParams();
  const { current, others } = useInsurancePage();
  const [showDialog, setShowDialog] = useState(false);

  return (
    <Container className="my-3">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
        <div className="d-flex flex-column flex-md-row">
          <div className="d-flex flex-row align-items-center me-3">
            <span className="d-block fw-bold">{pluralize(t('common:member'), 2)}: </span>
          </div>

          <div className="d-flex flex-row align-items-center me-3">
            <FontAwesomeIcon icon={faCircleCheck} size="sm" className="me-3 text-primary" />
            <span className="d-block">{t('common:myself')}</span>
          </div>

          {spouse && (
            <div className="d-flex flex-row align-items-center me-3">
              <FontAwesomeIcon icon={faCircleCheck} size="sm" className="me-3 text-primary" />
              <span className="d-block">{t('common:spouse')}</span>
            </div>
          )}

          {sons && (
            <div className="d-flex flex-row align-items-center me-3">
              <FontAwesomeIcon icon={faCircleCheck} size="sm" className="me-3 text-primary" />
              <span className="d-block">
                {`${pluralize(t('common:son'), sons.length)}: ${sons.length}`}
              </span>
            </div>
          )}

          {daughters && (
            <div className="d-flex flex-row align-items-center me-3">
              <FontAwesomeIcon icon={faCircleCheck} size="sm" className="me-3 text-primary" />
              <span className="d-block">
                {`${pluralize(t('common:daughter'), daughters.length)}: ${daughters.length}`}
              </span>
            </div>
          )}

          <Button variant="outline-primary" onClick={() => setShowDialog(true)} className="my-2">
            {t('common:change')}
          </Button>
        </div>

        <Dropdown>
          <Dropdown.Toggle className="w-100">{current.name}</Dropdown.Toggle>
          <Dropdown.Menu>
            {map(others, ({ name, to }) => (
              <Dropdown.Item as={Link} key={name} to={to} target="_blank">
                {name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <ConfirmModal
          show={showDialog}
          onHide={() => setShowDialog(false)}
          onConfirm={() => navigate((formLinkTo), { replace: true })}
        />
      </div>
    </Container>
  );
};

export { SubHeader };
